export class FormValidator {
    constructor(formSelector) {
        this.inputs = {};
        this.submitBtn = null;
        this.validateRules = {
            'js-validate-phone': /^[0-9+]{6,13}$/,
            'js-validate-name': /^[a-zA-Z\u0400-\u04FF]{2,30}$/,
            'js-validate-email': /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        };
        const foundForm = document.querySelector(formSelector);
        if (!foundForm) {
            return;
        }
        this.form = foundForm;
        this.collectElements();
        this.attachEvents();
        this.initialValidate();
        this.initForm();
    }
    collectElements() {
        const elements = this.form.querySelectorAll('input');
        const submitbutton = this.form.querySelector('[type="submit"]');
        if (submitbutton) {
            this.submitBtn = submitbutton;
        }
        elements.forEach(el => {
            if (!el.name)
                return;
            const isRequired = el.hasAttribute('required');
            this.inputs[el.name] = {
                name: el.name,
                isValid: isRequired ? false : true,
                required: isRequired,
                element: el
            };
        });
    }
    attachEvents() {
        Object.values(this.inputs).forEach(input => {
            input.element.addEventListener('input', () => {
                this.validateInput(input);
                this.updateSubmitState();
            });
            input.element.addEventListener('blur', () => {
                this.validateInput(input);
                this.updateSubmitState();
            });
        });
    }
    initialValidate() {
        Object.values(this.inputs).forEach(input => {
            this.validateInput(input, false);
        });
        this.updateSubmitState();
    }
    updateSubmitState() {
        if (!this.submitBtn)
            return;
        this.submitBtn.disabled = !this.validateAll();
    }
    validateInput(input, markUI = true) {
        const value = input.element.value.trim();
        if (input.required) {
            if (value.length === 0) {
                input.isValid = false;
                if (markUI)
                    this.markInvalid(input);
                return;
            }
        }
        let patternMatched = true;
        let hasPattern = false;
        for (const ruleClass in this.validateRules) {
            if (input.element.classList.contains(ruleClass)) {
                hasPattern = true;
                const regex = this.validateRules[ruleClass];
                patternMatched = regex.test(value);
                break;
            }
        }
        if (!input.required && value === '' && hasPattern) {
            input.isValid = true;
        }
        else if (hasPattern) {
            input.isValid = patternMatched;
        }
        else {
            input.isValid = true;
        }
        if (markUI) {
            if (!input.isValid) {
                this.markInvalid(input);
            }
            else {
                this.markValid(input);
            }
        }
    }
    validateAll() {
        Object.values(this.inputs).forEach(i => this.validateInput(i, false));
        return Object.values(this.inputs).every(input => input.isValid);
    }
    markInvalid(input) {
        input.element.classList.add('not-valid');
    }
    markValid(input) {
        input.element.classList.remove('not-valid');
    }
    initForm() {
        this.form.addEventListener('submit', (e) => {
            if (!this.validateAll()) {
                e.preventDefault();
                console.warn('Form validation failed');
                Object.values(this.inputs).forEach(i => {
                    if (!i.isValid)
                        this.markInvalid(i);
                });
                this.updateSubmitState();
                return;
            }
            console.log('Form is valid!');
        });
    }
}
